
import Tenant from "@/store/modules/system/tenant/entity";
import {Component, Mixins, FormModalMixins} from "@/lib";
import HiCheckboxSingle from "@/components/form/hi-checkbox-single.vue";
@Component({
  components: {HiCheckboxSingle}
})
export default class CreateTenant extends Mixins(FormModalMixins) {
  model = new Tenant();
  created(){
      Object.assign(this.config, {modelTitleL: "Action.Add",labelWidth:150, okAction:"system/tenant/create"});
  }

  test() {
    (this.$refs["form-modal"] as any).formValidate((model: any) => {
      console.warn("slot-button callback", model);
    });
  }
}
